import { createTheme } from '@mui/material/styles';
import { PrimaryColor } from 'app/style/AppColors';

export const theme = createTheme({
    palette: {
        // mode: 'light',
        primary: {
            main: PrimaryColor,
            dark: '#8e7433',
            light: '#b29040'
        },
        secondary: { main: PrimaryColor },
        background: {
            default: "#fafafa"
        },
        text: {
            // primary: PrimaryColor
        }
    },
    typography: {
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        // fontSize: 12,
    }
});
